<template>
  <div id="solution">
    <div>
      <div class="ment_ti">
      <img src="@/assets/mo/ping.png" alt="">
      <p>平台接入</p>
    </div>
    <ul style="margin-top:-10px;">
      <li v-for="(item, index) in list" :key="index">
        <div class="min_box">
          <div class="h5_tab" @click="clickTab(index)">
           
            <p>{{ item.name }}</p>
            <img
              class="h5_img"
              :src="
                item.type
                  ? 'https://www.bjecpower.com/camera/company/slicesBottom2.png'
                  : 'https://www.bjecpower.com/camera/company/slicesTop2.png'
              "
              alt=""
            />
          </div>
          <div
            class="h5_content"
            v-show="initSize() || (!initSize() && !item.type)"
          >
            <div class="h5_text" @click="pushIndexa(item)">
              {{ item.txt }}
            </div>
            <div class="h5_text" @click="pushIndexb(item)">
              {{ item.txta }}
            </div>
            <div class="h5_text" @click="pushIndexc(item)" v-if=" item.txtb !=''">
              {{ item.txtb }}
            </div>
            <div v-else></div>
          </div>
        </div>
      </li>
    </ul>
    </div>

     
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
        {
          name: "数据传输及安全",
          txt: "数据传输",
          txta: "安全",
          path: "",
          type: false,
        },
        {
          name: "桩站信息",
          txt: "充电站信息",
          txta: "充电设备信息",
          txtb: "接口规范",
          path: "",
          
          type: true,
        },
        {
          name: "交易流程",
          txt: "交易流程",
          txta: "对账和结算",
          path: "",
          
          type: true,
        },
      ],
     
    };
  },
  mounted(){
    
  },
  methods: {
    pushIndexa(e){
      if(e.txt == '数据传输'){
        this.$router.push("/documoa")
      }
      if(e.txt == '充电站信息'){
        this.$router.push("/documoc")
      }
      if(e.txt == '交易流程'){
        this.$router.push("/documof")
      }
    },
    pushIndexb(e){
      if(e.txta == '安全'){
        this.$router.push("/documob")
      }
      if(e.txta == '充电设备信息'){
        this.$router.push("/documod")
      }
      if(e.txta == '对账和结算'){
        this.$router.push("/documog")
      }
    },
    pushIndexc(e){
      if(e.txtb == '接口规范'){
        this.$router.push("/documoe")
      }
     
    },
    goDetail() {
      if (this.initSize()) {
        alert("小傻瓜~");
      }
    },
    clickTab(index) {
      console.log(index)
      if (!this.initSize()) {
        this.list[index].type = !this.list[index].type;
        // document.getElementsByTagName('li')[index].style.margin = ''
      }
    },
   
    clickTabHu(index){
      console.log(index)
      if(index == 0 ){
        this.$router.push("/documenth")
      }
       if(index == 1 ){
        this.$router.push("/documentj")
      }
       if(index == 2 ){
        this.$router.push("/documentk")
      }
       if(index == 3 ){
        this.$router.push("/documentl")
      }
    },
    initSize() {
      return document.body.clientWidth > 768;
    },
  },
};
</script>

<style scoped>
.ment_ti{
  height:74px;
  display: flex;
  align-items: center;
  align-content: left;
}
.ment_ti img{
  width:18px;
  height:18px;
  margin:0 8px 0px 15px;
}
.ment_ti p{
  font-size: 19px;
font-family: PingFang-SC-Bold, PingFang-SC;
font-weight: bold;
color: #191C27;
line-height: 74px;
text-align: left;
}
#solution {
  width: 100%;
  height: 489.5px;
  box-sizing: border-box;
  padding: 64px 220px 95px 220px;
  background-image: url("https://www.bjecpower.com/camera/company/cp.png");
  background-size: 100%;
  background-repeat: no-repeat;
}
.solution_title {
  width: 100%;
  font-size: 32px;
  color: #191c27;
  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
  font-weight: 500;
  text-align: center;
}
ul {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 56px;
  /* background: rgba(55, 146, 230, 0.18); */
  position: relative;
}
li {
  width: 33.3%;
  background: #fff;
  height: 241px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 32px 32px 35px 32px;
  position: absolute;
  position: relative;
  text-align: left;
  border: 1px solid #e5e5e5;

  top: 0;
  transition: 1s;
}
li:nth-child(1) {
  border-right: none;
}
li:nth-child(3) {
  border-left: none;
}
li:hover {
  /* box-shadow: 0px 2px 25px 0px rgba(55, 146, 230, 0.18); */
  animation: top 0.5s linear;
  top: -30px;
}
@keyframes top {
  0% {
    top: 0;
  }
  100% {
    top: -30px;
  }
}
li:hover .goTodetail {
  display: block;
}
li > .max_box > img {
  width: 76px;
  height: 76px;
}
.min_box > .h5_tab > .h5_img {
  display: none;
  position: absolute;
  width: 15px;
  height: 8px;
  right: 15px;
  top: 26px;
}
li > .max_box > p {
  font-size: 20px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #191c27;
  margin: 15px 0 10px 0;
}
li > .max_box > span {
  font-size: 15px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #9ea5bb;
}
.goTodetail:hover {
  background: #016ed3;
}
.goTodetail {
  width: 100%;
  height: 35px;
  background: #0084ff;
  box-sizing: border-box;
  display: flex;
  line-height: 35px;
  position: absolute;
  bottom: 0;
  left: 0;
  padding-left: calc(50% - 35px);
  display: none;
  cursor: pointer;
}
.goTodetail > span {
  font-size: 13px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #ffffff;
}
.goTodetail > img {
  width: 4px;
  height: 8px;
  margin: 14.5px 0 0 6px;
}
.h5_text {
  display: none;
}
.min_box {
  display: none;
}
@media screen and (max-width: 768px) {
  .max_box {
    display: none;
  }
  #solution {
    padding: 0;
    background-image: none;
    height: auto;
  }
  .solution_title {
    /* height: 22px; */
    font-size: 22px;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #191c27;
    text-align: center;
  }
  ul {
    margin-top: 10px;
    flex-direction: column;
    margin-bottom:40px;
    background: #F6F7FA;
  }
  li {
    width: 100%;
    margin: 0;
    padding: 0px;
    height: auto;
    border: none;
    background: #fff;
    cursor: pointer;
  }
  li:hover {
    top: 0;
    animation: none;
  }
  .min_box {
    width: 100%;
    height: 100%;
    display: block;
  }
  .min_box > .h5_tab {
    height: 60px;
    width: 100%;
    background: #fff;
    display: flex;
    padding: 15px;
    box-sizing: border-box;
    border: none;
  }
  .min_box > .h5_tab > img {
    width: 32px;
    height: 31px;
  }
  .min_box > .h5_tab > p {
    /* margin: 0 0 0 17px; */
    font-size: 17px;

    font-weight: 500;
    color: #191c27;
    line-height: 32px;
  }
  .min_box >  .hu_tab >p{
    width:100%;
    height:64px;
    line-height: 64px;
    font-size: 18px;
    border-top: 1px solid #E5E5E5;
font-family: PingFang-SC-Medium, PingFang-SC;
font-weight: 500;
color: #191C27;
  }
  .min_box > .h5_tab > .h5_img {
    display: block;
  }
  .h5_content {
    background: #f6f7f9;
    padding-left: 15px;
    min-height:80px;
    box-sizing: border-box;
  }
  .h5_content span {
    width: 104px;
    height: 40px;
    background: #0084ff;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    display: inline-block;
    font-weight: 500;
    color: #ffffff;
  }
  .h5_text {
    /* height: 53px; */
    background: #f6f7fa;
    display: block;
    font-size: 17px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: #191c27;
    line-height: 53px;
    /* margin-bottom: 24px; */
  }
   .h5_text :hover{
    background: #F6F7FA;
  }
  .h5_text :active{
    background: #F6F7FA;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/document/mentmo.vue